import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthenticationService } from '../services/authentication.service';
import { IAuthentication } from '../services/authentication.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private location: Location,
  ) {}

  canActivateChild(): Observable<boolean> {
    return this.authService.user$.pipe(
      map((user: IAuthentication) => {
        if (user.loggedIn) {
          if (user.requiredDocuments && user.requiredDocuments.length > 0) {
            this.router.navigate(['legal']);
            return false;
          }
          return true;
        } else {
          let path = this.location
            ? (this.location.path()?.split('?')?.[0] ?? '/')
            : '/';
          path += this.authService.getValidQueryParametersForLoginPath(
            this.location.path(),
          );
          this.router.navigate(['/auth/login'], {
            queryParams: { path: path },
          });
          return false;
        }
      }),
    );
  }
}
